export enum ApprovalStatus {
  Approved = 'approved',
  Deleted = 'deleted',
  Failed = 'failed',
  Pending = 'pending',
  Rejected = 'rejected',
}
